<template>
  <ul ref="list" :class="['menu', modificatorClass]">
    <li
      @click="hideMenu"
      class="menu__item"
      :key="index"
      v-for="(item, index) in links"
    >
      <BaseLink
        class="menu__link"
        :class="[
          $route.path.includes('/participants-page') &&
            item.href === '/participants-page' &&
            'nuxt-link-active'
        ]"
        :name="item.name"
        :href="`${item.href}`"
      />
    </li>
  </ul>
</template>

<script>
import { EventBus } from '~/plugins/eventBus.js'

export default {
  name: 'MenuList',
  props: {
    links: {
      type: Array,
      required: true
    },
    modificatorClass: {
      type: String,
      required: true
    }
  },
  methods: {
    hideMenu() {
      EventBus.$emit('menuLinkClicked')
    }
  }
}
</script>

<style lang="scss">
.menu {
  $parent: &;

  margin: 0;
  padding: 0;
  list-style: none;

  &__link {
    @include easeOut;

    font-family: $ToyotaBook;
    font-size: 20px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 2.1;
    letter-spacing: normal;
    color: #282830;
    text-decoration: none;

    &--active,
    &:hover {
      color: #ff0022 !important;
    }
  }

  &--header {
    display: none;
  }

  &--footer {
    margin-bottom: 35px;
    text-align: center;

    #{$parent}__item {
      &:not(:last-of-type) {
        margin-bottom: 12px;
      }
    }

    #{$parent}__link {
      font-size: 16px;
      line-height: 1.6;
      color: #6a6b70;
    }
  }

  .nuxt-link-active {
    color: #ff0022 !important;
  }
}

@include media-min($tablet-width) {
  .menu {
    $parent: &;

    &--header {
      flex-grow: 1;
      display: flex;
      margin: 0 36px 0 25px;

      #{$parent}__item {
        &:not(:last-of-type) {
          margin-right: 25px;
        }
      }

      #{$parent}__link {
        font-size: 13px;
        line-height: 1.62;
      }
    }

    &--footer {
      display: flex;
      flex-wrap: wrap;
      margin: 0 160px 0 0;

      #{$parent}__item {
        display: flex;
        justify-content: space-between;
        align-items: center;

        &:not(:last-of-type) {
          margin: 0 30px 0 0;
        }

        &:nth-of-type(3) {
          margin-right: 0;
        }

        &:last-of-type {
          margin-right: auto;
        }

        &:nth-of-type(-n + 3) {
          margin-bottom: 12px;
        }
      }
    }
  }
}

@include media-min($desktop-width) {
  .menu {
    $parent: &;
    flex-grow: 1;

    &--header {
      margin: 0 auto 0 36px;

      #{$parent}__link {
        font-size: 16px;
        line-height: 1.6;
      }

      #{$parent}__item {
        &:not(:last-of-type) {
          margin-right: 36px;
        }
      }
    }

    &--footer {
      // justify-content: space-between;
      margin-right: 220px;

      #{$parent}__item {
        &:nth-of-type(-n + 3) {
          margin-bottom: 0;
        }

        &:not(:last-of-type) {
          margin: 0 40px 0 0;
        }

        &:last-of-type {
          margin-right: initial;
        }
      }

      #{$parent}__link {
        font-size: 16px;
        line-height: 1.6;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// components/MenuList.vue